var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"px-2 md:px-6 mb-12"},[(_vm.campaign.length > 0)?_c('section',[_vm._m(0),_c('campaign-slider',{attrs:{"data":_vm.campaign}})],1):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex mb-6"},[_c('h4',[_c('strong',[_vm._v("Campaign")])])])
}]

export { render, staticRenderFns }